import React from 'react';
// import { FaUser, FaBell, FaGem , FaMotorcycle, FaMoneyBillWave, FaHeart, FaChevronDown } from 'react-icons/fa';
import './App.css'
import MenuTinChap from './components/tinchap/menu/MenuTinChap';
import MenuSideBar from './components/tmp/MenuSideBar';
import CpnDongTienLai from './components/tinchap/item_menu/CpnDongTienLai';
import MenuAnt from './components/MenuAnt';
import FlexTest from './components/tmp/FlexTest';
import LandingLogin from './components/LandingLogin'
import { Routes, Route } from 'react-router-dom';
// const App = () => {

//   return (<LandingLogin/>);
// };


const App = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingLogin />} />      
    </Routes>
  );
};




export default App;
